import {
    ButtonHTMLAttributes,
    ChangeEventHandler,
    FormEvent,
    ReactElement,
    useState,
} from "react";
import FrameButton from "../buttons/FrameButton";
import {validateEmail} from "@/utils/validateEmail";
import useOverwolfInterop from "@/hooks/useOverwolfInterop";
import { MdEmail, MdPhone } from "react-icons/md";

interface Props {
    initialEmail?: string;
    onSubmit: (emailOrPhone: string) => void;
    onPhoneSubmit?: (phone: string) => void;
}

function LoginEmail(props: Props): ReactElement {
    const { isOnOverwolf } = useOverwolfInterop();
    const [emailOrPhone, setEmailOrPhone] = useState<string>(props.initialEmail || "");
    const [inputType, setInputType] = useState<"email" | "phone">("email");

    const handleInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        setEmailOrPhone(e.target.value);
    };

    function handleSubmit(e: FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        if (inputType === "phone" && props.onPhoneSubmit) {
            props.onPhoneSubmit(emailOrPhone);
        } else {
            props.onSubmit(emailOrPhone);
        }
    }

    const isValidInput = () => {
        if (inputType === "email") {
            return validateEmail(emailOrPhone);
        }
        // Phone validation - must have country code and number
        return emailOrPhone.startsWith("+") && emailOrPhone.length >= 10;

    };

    return (
        <form onSubmit={handleSubmit}>
            {/* Phone authentication temporarily disabled
            <div className="login-input-toggle">
                <button
                    type="button"
                    className={`login-input-toggle__option ${inputType === 'email' ? 'active' : ''}`}
                    onClick={() => {
                        setInputType('email');
                        setEmailOrPhone('');  // Clear input when switching
                    }}
                >
                    <MdEmail />
                    <span>Email</span>
                </button>
                <button
                    type="button"
                    className={`login-input-toggle__option ${inputType === 'phone' ? 'active' : ''}`}
                    onClick={() => {
                        setInputType('phone');
                        setEmailOrPhone('');  // Clear input when switching
                    }}
                >
                    <MdPhone />
                    <span>Phone</span>
                </button>
            </div>
            */}

            <div className="login-page_content_email-container">
                {/* Always show email input since phone is disabled */}
                <input
                    type="email"
                    required
                    placeholder="Enter your email address"
                    value={emailOrPhone}
                    onChange={handleInputChange}
                />
                {/* Phone input temporarily disabled
                {inputType === 'email' ? (
                    <input
                        type="email"
                        required
                        placeholder="Enter your email address"
                        value={emailOrPhone}
                        onChange={handleInputChange}
                    />
                ) : (
                    <PhoneInputWithCountry
                        value={emailOrPhone}
                        onChange={(value) => setEmailOrPhone(value)}
                        placeholder="Phone number"
                    />
                )}
                */}
            </div>

            <FrameButton<ButtonHTMLAttributes<HTMLButtonElement>>
                color={!isOnOverwolf ? "purple" : "purple-blue-gradient-shadow"}
                size="normal"
                className="login-page_content_login-button"
                forwardProps={{
                    type: "submit",
                    disabled: !isValidInput(),
                }}
            >
                Continue
            </FrameButton>
        </form>
    );
}

export default LoginEmail;